import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import { getGetUserByUsernameQueryKey, getUserByUsername } from 'ze-sdk';
const userQuery = createQueryKeys('user', {
    byUsername: (username)=>({
            queryKey: username ? getGetUserByUsernameQueryKey({
                username
            }) : [
                'user',
                'by-username',
                'missing'
            ],
            queryFn: async ()=>{
                if (!username) {
                    return null;
                }
                const { value } = await getUserByUsername({
                    username
                });
                return value;
            }
        })
});
export function useUser(username) {
    const { data: user, isLoading, error } = useQuery(userQuery.byUsername(username));
    return {
        user,
        isLoading,
        error
    };
}
